import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-checkbox', {
    mixins: [FormElementMixin],
    data() {
        return {
            removeFromListener:  ['change','input','updateState'],
        }
    },
}, 'form/controls/ak-checkbox.html');